<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :title="title"
    width="1300px"
    :before-close="cancel"
    class="main-content change-charge-window"
  >
    <div class="section grid-wrapper">
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        config-module="13011101"
        :row-data="rowData"
        min-height="400px"
      />
    </div>
    <div v-if="totalCurrencyCharge.arData.length > 0" class="pagination-wrapper">
      <div style="display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;">
        <span>{{ $t('CargoMsg.Cargo_Receivable2') }}</span>
        <charge-currency-total-group
          v-if="totalCurrencyCharge.arData.length>0"
          :amount-to-currency="localCurrency"
          :data-provider="totalCurrencyCharge.arData"
          :data-field="'amount'"
          rate-field="exchangeRate"
          :is-gross-profit="true"
          type="ar"
        />
      </div>
    </div>
    <div v-if="totalCurrencyCharge.apData.length > 0" class="pagination-wrapper">
      <div :style="totalCurrencyCharge.arData.length > 0 ?`display: flex;justify-content: flex-end;flex-wrap: wrap;`:'display: flex;justify-content: flex-end;flex-wrap: wrap;margin-top: 10px;'">
        <span>{{ $t('CargoMsg.Cargo_Payable2') }}</span>
        <charge-currency-total-group
          v-if="totalCurrencyCharge.apData.length>0"
          :amount-to-currency="localCurrency"
          :data-provider="totalCurrencyCharge.apData"
          :data-field="'amount'"
          rate-field="exchangeRate"
          :is-gross-profit="true"
          type="ap"
        />
      </div>
    </div>
    <div slot="footer">
      <div v-if="defaultProperties.editMode === 'add'" style="float: left;margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="add">{{ $t('CargoMsg.Cargo_add') }}</el-button>
        <el-button
          v-if="job && privilege.copyCharge"
          id="btnCopyCharge"
          type="primary"
          @click="copyChargeHandler()"
        >{{ $t('FinanceManage.charge_copyCharge') }}
        </el-button>
        <!--费用方案-->
        <el-button
          v-if="job && privilege.chargeProject"
          no="charge_sp7"
          type="primary"
          @click="chargeSchemeHandler()"
        >{{ $t('FinanceManage.charge_sp7') }}
        </el-button>
        <el-button type="danger" size="mini" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
      </div>
      <div style="float: right;margin-bottom: 10px">
        <el-button type="primary" size="mini" @click="saveEvent">{{ $t('SeaExport.Confirm') }}</el-button>
        <el-button size="mini" @click="cancel">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </div>
    <!-- 抄录费用弹窗 -->
    <copy-charge-dialog
      :visible.sync="copyChargeDialog.visible"
      :lob="copyChargeDialog.lob"
      :is-sea="copyChargeDialog.isSea"
      :job="job"
      :receivable="copyChargeDialog.receivable"
      view-source="ChangeCharge"
      @selectedCopyChargeHandler="(chargeList) => { selectedCopyChargeHandler(chargeList) }"
    />
    <!-- 费用方案导入弹窗 -->
    <charge-scheme-batch-dialog
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :original-condition="chargePlanDialog.originalCondition"
      :charge-scheme-is-approved="chargePlanDialog.chargeSchemeIsApproved"
      :source="chargePlanDialog.source"
      :job="job"
      @selectedSchemeHandler="(schemeDetails) => { selectedSchemeHandler(schemeDetails) }"
    />
  </el-dialog>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor/index'
import CargoAgGridAdvanceMultipleSelectEditor
  from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'
import { Charge } from '@/class/model/act/Charge'
import StrUtils from '@/utils/StrUtils'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getLoading } from '@/utils/utilBaseElement'
import { batchCreateChangeCharge } from '@/api/clearing/changeCharge'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index'
import { deepClone, getUuid } from '@/utils'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { ChargeUtils } from '@/class/cargo/model/utils/ChargeUtils'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import { getGridSelected } from '@/utils/agGrid'
import { chargeItemCompatibleLanguage, multiply, Once, sleep } from '@/utils/commonUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import CopyChargeDialog from '@/views/cargo/v0/SeaExport/components/booking/copyChargeDialog.vue'
import DateUtils from '@/utils/dateUtils'
import * as ChargeUtilsForConstant from '@/class/cargo/model/utils/ChargeUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { cache } from '@/utils/cacheManager'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import BigNumber from 'bignumber.js'
import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import { saveChargeSchemeByJob } from '@/api/booking/job'

export default {
  name: 'ChangeChargeDialog',
  components: { CopyChargeDialog, ChargeCurrencyTotalGroup, CargoAdvanceSelect, ChargeSchemeBatchDialog },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true }, // 弹框打开时默认传递条件
    applyChangeCharge: { type: Boolean, default: false }, // 是否申请更改费用
    inputIncludingTaxUnitPrice: { type: Number, default: 0 }, // 单价是否含税
    showWhtTax: { type: Boolean, default: false }
  },
  data() {
    return {
      userId: 0,
      officeId: 0,
      departmentId: 0,
      selectTypeNames: TYPE_NAMES,
      privilege: {
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']), // 是否有应收受控费用权限
        copyCharge: this.$checkPermission(['role_Charge_copyCharge']), // 抄录费用
        chargeProject: this.$checkPermission(['role_Charge_chargeProject']), // 费用方案(费用页签)
        showOtherBranchCharge: RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_showOtherBranchCharge']) // 查看结算公司是其他协作分公司的费用
      },
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onSelectionChanged: this.toRefreshSelectedCountChargeGrid,
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridSelectEditor,
          CargoAgGridAdvanceMultipleSelectEditor,
          CargoAgGridCommonTextareaEditor
        }
      },
      gridParams: {},
      gridApi: {},
      rowData: [],
      isAr: false,
      lob: '',
      loading: false,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        companyCmpIdxForCustomerMap: new Map(), // 结算单位
        chargeMeasureSet: new Set(), // 费用单位
        mblCargoDocSet: new Set(), // 关单号set
        hblCargoDocSet: new Set(), // 关单号set
        officeIdForDepartmentMap: new Map(),
        officeIdForClearDepartmentMap: new Map(), // 结算公司
        currencySet: new Set(),
        userAllSet: new Set(), // cache中取得全部用户集合
        containerNoAllSet: new Set(), // 全部箱号
        user4AuditorSet: new Set(), // 审核人数据集合
        paymentTermSet: new Set(),
        customerDefaultTitleMap: new Map(), // 委托单位和默认发票抬头
        customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
        customerSettlementAgentMap: new Map(), // 结算对象关联的结算代理
        chargeItemSet: new Set()
      },
      config: {
        isInputChargeBaseOnService: false, // 是否按服务项目录入费用
        inputIncludingTaxUnitPrice: 0, // 单价是否含税
        currentOfficeCharge: false // 是否开启选择不同操作公司后费用结算公司为当前分公司
      },
      once: new Once(this),
      localCurrency: 'RMB',
      totalCurrencyCharge: { // 右下角合计组件相关参数
        selectedCount: 0,
        arData: [],
        apData: []
      },
      dateType: '',
      copyChargeDialog: {
        visible: false,
        selectedJobs: [],
        isSea: false,
        lob: 'SE',
        receivable: 0
      },
      chargePlanDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        lob: 'SE',
        source: 'tabCharges',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      copyedChargeList: [],
      tabCost: { // 应收
        grid: {
          uuidPrefixRule: 'addTabCost__' // 临时新增的uuid规则
        }
      },
      tabSelling: { // 应收
        grid: {
          uuidPrefixRule: 'addTabSelling__' // 临时新增的uuid规则
        }
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    language() {
      return this.$store.getters.language === 'zh'
    },
    job() {
      return this.defaultProperties.job
    },
    title() {
      if (this.defaultProperties.editMode === 'add') {
        return this.$t('ChangeCharge.applyAddCharge')
      }
      if (this.defaultProperties.editMode === 'edit') {
        return this.$t('ChangeCharge.applyChangeCharge')
      }
      if (this.defaultProperties.editMode === 'del') {
        return this.$t('ChangeCharge.applyDeleteCharge')
      }
      return ''
    },
    editable() {
      return this.defaultProperties.editMode !== 'del'
    },
    columnDefs() {
      const result = [
        {
          headerName: ' ', maxWidth: 30, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('FinanceManage.charge_chargeItem'),
          colId: 'chargeItemId',
          field: 'chargeItemId',
          initialWidth: 180,
          lockVisible: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: this.getChargeItemFilter(),
              tagValue: 'itemId',
              tagName: this.language ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('ChangeCharge.changeReason'),
          editable: true,
          colId: 'changeReason',
          field: 'changeReason',
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
          colId: 'accountId',
          field: 'accountId',
          initialWidth: 180,
          valueFormatter: (params) => {
            return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Company,
              tagValue: 'cmpIdx',
              tagName: 'chineseName',
              methodParams: { active: true },
              autoKey: 'auto_0',
              dataFilterFunction: (item, inputVal) => {
                if (item.cmpIdx === inputVal) {
                  return true
                }
                return true
                // return this.config.isInputChargeBaseOnService
              },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_invoiceHeader'),
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          colId: 'invoiceTitle',
          field: 'invoiceTitle',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'invoiceTitle',
              tagName: 'invoiceTitle',
              allowCreate: true,
              staticOptions: this.getInvoiceTitleList(params.data.accountId),
              filterable: true,
              filterTagNames: ['invoiceTitle'],
              filterType: 'global'
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_somesticOrInternational'),
          colId: 'oversea',
          field: 'oversea',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.internal') }, { code: true, value: this.$t('SeaExport.overseas') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_drawABillOrNot'),
          colId: 'needInvoice',
          field: 'needInvoice',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Payment.controlledOrNot'),
          colId: 'controlled',
          field: 'controlled',
          initialWidth: 180,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && (this.defaultProperties.isAr ? this.privilege.isCostControlled : this.privilege.isControlled),
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => ({
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          }),
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_exchangeRate'),
          colId: 'exchangeRate',
          field: 'exchangeRate',
          initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DateType'),
          colId: 'dateType',
          field: 'dateType',
          initialWidth: 130,
          valueFormatter: (params) => {
            return params.value === 'BusinessDate' ? this.$t('Message.ByBusinessDate') : this.$t('Message.ByAdjustmentDate')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: 'AdjustmentDate', value: this.$t('Message.ByAdjustmentDate') }, { code: 'BusinessDate', value: this.$t('Message.ByBusinessDate') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unit'), colId: 'measure', field: 'measure', initialWidth: 180,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              methodParams: { unit: true, seaFreight: true },
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_quantity'), colId: 'quantity', field: 'quantity', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          },
          editable: (params) => this.editable && !params.data.uuid,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions,
                filterable: true,
                filterTagNames: ['code', 'chineseName']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPrice'), colId: 'unitRate', field: 'unitRate', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxExcludedPrice'),
          colId: 'excludingTaxAmount1',
          field: 'excludingTaxAmount',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_taxRate'), colId: 'taxRate', field: 'taxRate', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          initialWidth: 180,
          cellClass: 'ag-right-aligned-cell',
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => this.editable && !!this.inputIncludingTaxUnitPrice,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }],
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          hide: !this.inputIncludingTaxUnitPrice,
          suppressColumnsToolPanel: !this.inputIncludingTaxUnitPrice
        },
        {
          headerName: this.$t('FinanceManage.charge_taxAmount'), colId: 'taxAmount', field: 'taxAmount', initialWidth: 180,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: false
        },
        {
          headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: false
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_contactPerson'),
          colId: 'contactPerson',
          field: 'contactPerson',
          initialWidth: 180,
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = this.currentViewCacheData.companyContactPersonMap.get(params.data.accountId)
            return {
              selectProps: {
                tagValue: 'contactPerson',
                tagName: 'contactPerson',
                staticOptions,
                filterable: true,
                filterTagNames: ['contactPerson']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridSelectEditor',
          cellEditorParams: (params) => {
            const staticOptionsMbl = [...this.currentViewCacheData.mblCargoDocSet]
            const staticOptionsHbl = [...this.currentViewCacheData.hblCargoDocSet]
            const optionsMBLValue = {}
            const optionsHBLValue = {}
            if (staticOptionsMbl.length > 0) {
              optionsMBLValue.label = 'MBL No.'
              optionsMBLValue.options = staticOptionsMbl
              optionsMBLValue.filterable = true
            }
            if (staticOptionsHbl.length > 0) {
              optionsHBLValue.label = 'HBL No.'
              optionsHBLValue.options = staticOptionsHbl
              optionsHBLValue.filterable = true
            }
            return {
              isGroup: true,
              tagValue: 'chargeRelatedBLNo',
              tagName: 'chargeRelatedBLNo',
              options: [optionsMBLValue, optionsHBLValue]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200,
          headerClass: 'ag-header-cell-left',
          cellStyle: {
            textAlign: 'left'
          },
          editable: (params) => this.editable,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...this.currentViewCacheData.containerNoAllSet]
            return {
              selectProps: {
                tagValue: 'containerNo',
                tagName: 'containerNo',
                staticOptions,
                filterable: true
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }
      ]
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'), field: 'whtTaxRate', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: params => this.editable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'), field: 'whtTaxAmount', width: 100,
          hide: !this.showWhtTax,
          suppressColumnsToolPanel: !this.showWhtTax,
          cellStyle: {
            textAlign: 'right'
          },
          valueFormatter: (params) => {
            return this.whtTaxAmountConversionRMBLabel(params.data)
          }
        })
      }
      return result
    },
    dateTypeConfigKeyAr() {
      return this.$route.name + '_ChangeChargeDialog_Ar_DateType'
    },
    dateTypeConfigKeyAp() {
      return this.$route.name + '_ChangeChargeDialog_Ap_DateType'
    },
    // 申请修改费用缓存
    dateTypeModifyConfigKeyAr() {
      return this.$route.name + '_ChangeChargeDialog_Ar_DateType_Modify'
    },
    dateTypeModifyConfigKeyAp() {
      return this.$route.name + '_ChangeChargeDialog_Ap_DateType_Modify'
    }
  },
  created() {
    this.userId = this.$store.getters.userId
    this.officeId = this.$store.getters.currentOfficeId
    this.departmentId = this.$store.getters.currentDeptId
    this.onShow()
    this.initializeHandler()
  },
  async mounted() {
    if (this.defaultProperties.editMode !== 'add') {
      this.rowData = deepClone(this.defaultProperties.charge)
      const arData = []
      const apData = []
      for (const charge of this.rowData) {
        const localCurrency = RateUtil.localCurrencyByOfficeId(charge.branchId)
        const exchangeRateNow = await RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, new Date(), charge.branchId)
        const exchangeRateJob = await RateUtil.getForeignExchangeRateSafely(localCurrency, charge.currency, ['SE', 'AE', 'RE'].includes(this.job.lob) ? this.job.etd : this.job.eta, charge.branchId)
        if (Number(exchangeRateNow) === Number(exchangeRateJob)) {
          if (this.defaultProperties.editMode === 'edit') {
            this.getCache(this.dateTypeModifyConfigKeyAr, this.dateTypeModifyConfigKeyAp)
            if (!this.dateType) {
              charge.dateType = 'AdjustmentDate'
            } else {
              charge.dateType = this.dateType
            }
          }
        } else if (Number(charge.exchangeRate) === Number(exchangeRateJob)) {
          if (this.defaultProperties.editMode === 'edit') {
            this.getCache(this.dateTypeModifyConfigKeyAr, this.dateTypeModifyConfigKeyAp)
            if (!this.dateType) {
              charge.dateType = 'BusinessDate'
            } else {
              charge.dateType = this.dateType
            }
          }
        } else {
          if (this.defaultProperties.editMode === 'edit') {
            this.getCache(this.dateTypeModifyConfigKeyAr, this.dateTypeModifyConfigKeyAp)
            if (!this.dateType) {
              charge.dateType = 'AdjustmentDate'
            } else {
              charge.dateType = this.dateType
            }
          }
        }
        if (charge.receivable) {
          arData.push(charge)
        } else {
          apData.push(charge)
        }
        if (charge.dateType === 'AdjustmentDate') {
          charge.auditDate = DateUtils.customFormat(new Date(), 'YYYY-MM-DD')
        }
        await ChargeColumnUtil.dateTypeChangeHandler(charge, this.job)
      }

      this.totalCurrencyCharge.arData = arData
      this.totalCurrencyCharge.apData = apData
      return
    }
    this.$nextTick(() => {
      this.add()
    })
  },
  beforeDestroy() {
    if (this.defaultProperties.editMode === 'add') {
      if (this.defaultProperties.isAr) {
        LocalStorageUtilsNew.setConfiguration(this.dateTypeConfigKeyAr, this.dateType)
      } else {
        LocalStorageUtilsNew.setConfiguration(this.dateTypeConfigKeyAp, this.dateType)
      }
    } else if (this.defaultProperties.editMode === 'edit') {
      if (this.defaultProperties.isAr) {
        LocalStorageUtilsNew.setConfiguration(this.dateTypeModifyConfigKeyAr, this.dateType)
      } else {
        LocalStorageUtilsNew.setConfiguration(this.dateTypeModifyConfigKeyAp, this.dateType)
      }
    }
  },
  methods: {
    // 初始化权限及配置参数
    async initializeHandler() {
      // 是否开启选择不同操作公司后费用结算公司为当前分公司
      this.config.currentOfficeCharge = parseInt(cache.config.get('CurrentOfficeCharge')) === 1
    },
    async onShow() {
      this.initCurrencySet()
      this.initChargeItemSet()
      this.setLocalCurrency()
    },
    async add() {
      const item = new Charge().fillDefaultValue().getData()
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.officeId)
      item.localCurrency = localCurrency
      item.currency = localCurrency
      item.jobUuid = this.job.uuid
      item.businessDate = this.job.businessDate
      item.inputBy = this.userId
      item.inputDate = new Date()
      item.auditDate = new Date()
      item.inputByDep = this.departmentId
      item.branchId = this.officeId
      item.receivable = this.defaultProperties.isAr
      item.verifiedAmount = 0
      item.adjustment = true
      item.offsetState = 0
      item.chargeState = 0
      item.measure = 'NML'
      if (this.dateType.length === 0) {
        // 日期类型
        if (this.defaultProperties.isAr) {
          this.dateType = LocalStorageUtilsNew.getConfiguration(this.dateTypeConfigKeyAr, 'string')
        } else {
          this.dateType = LocalStorageUtilsNew.getConfiguration(this.dateTypeConfigKeyAp, 'string')
        }
        if (!this.dateType) {
          this.dateType = 'AdjustmentDate'
        }
      }
      item.dateType = this.dateType
      const office = this.$store.getters.currentOffice
      if (office && String(office.taxRate) !== 'NaN') {
        item.taxRate = office.taxRate
      } else {
        item.taxRate = 0
      }
      item.taxRate = ChargeUtils.getTaxRateAtCreateCharge(item)
      item.unitPriceIncludeTax = this.inputIncludingTaxUnitPrice === 2
      this.rowData.push(item)
      this.gridOptions.api.refreshCells({ force: true })
      let arCount = 0
      let apCount = 0
      const arData = []
      const apData = []
      for (const item of this.rowData) {
        if (item.receivable) {
          arCount = arCount + 1
          arData.push(item)
        } else {
          apCount = apCount + 1
          apData.push(item)
        }
      }
      this.totalCurrencyCharge.arData = arData
      this.totalCurrencyCharge.apData = apData
      this.totalCurrencyCharge.arCount = arCount
      this.totalCurrencyCharge.apCount = apCount
    },
    remove() {
      const api = this.gridOptions.api
      const rows = api.getSelectedRows()
      api.updateRowData({ remove: rows })
      const rowData = []
      api.forEachNode(node => rowData.push(node.data))
      this.rowData = rowData
      this.gridOptions.api.refreshCells({ force: true })
      const arData = []
      const apData = []
      for (const item of this.rowData) {
        if (item.receivable) {
          arData.push(item)
        } else {
          apData.push(item)
        }
      }
      this.totalCurrencyCharge.arData = arData
      this.totalCurrencyCharge.apData = apData
    },
    async saveEvent() {
      if (this.defaultProperties.editMode === 'del') {
        this.applyDeleteCharge()
        return
      }
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      const changeCharges = []
      if (!await ChargeUtils.checkUnitRate(this.rowData, this)) {
        return
      }
      for (const item of this.rowData) {
        if (!this.validateCharge(item)) {
          return
        }
        item.serialNumber = this.refreshSerialNumber(item.isAr, this.job.charges)
        const changeCharge = {}
        changeCharge.changeReason = item.changeReason
        changeCharge.branchId = this.$store.getters.currentOfficeId
        changeCharge.actionType = this.defaultProperties.editMode === 'add' ? 1 : 0
        changeCharge.chargeVO = item
        changeCharges.push(changeCharge)
      }
      await this.toApplyCharge(changeCharges)
    },
    async onCellChange(params) {
      console.log('cellChange', params)
      const { node, data } = params
      if (params.colDef.field === 'exchangeRate') {
        const exchangeRate = CurrencyUtil.truncateRateByCurrency(data.currency, data.exchangeRate)
        if (exchangeRate !== data.exchangeRate) {
          node.setDataValue('exchangeRate', exchangeRate)
          return
        }
      }
      let firstAccountId = false
      if (!params.oldValue) {
        firstAccountId = true
      }
      const newParams = {
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        firstAccountId: firstAccountId,
        originalValue: params.oldValue
      }
      if (params.colDef.field === 'dateType') {
        this.dateType = params.newValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
      this.$nextTick(() => {
        const arData = []
        const apData = []
        for (const item of this.rowData) {
          if (item.receivable) {
            arData.push(item)
          } else {
            apData.push(item)
          }
        }
        this.totalCurrencyCharge.arData = arData
        this.totalCurrencyCharge.apData = apData
      })
    },
    async chargeGridItemEditEndHandler(params) {
      console.log('cellChange', params)
      const job = this.job
      const charge = params.data
      const oldInvoceTitle = charge.invoiceTitle
      const oldChargeItemId = charge.chargeItemId
      const oldWhtTaxRate = charge.whtTaxRate
      const oldExcludingTaxAmount = charge.excludingTaxAmount
      await ChargeColumnUtil.changeChargeCellChangeHandler(params, job, this.currentViewCacheData, this.inputIncludingTaxUnitPrice, this.config.currencyChangeBySettlementAccount)
      // 加载开票抬头
      await this.getTitlesByCompanyId(charge)
      if (charge.invoiceTitle) {
        if (params.field === 'invoiceTitle' || charge.invoiceTitle !== oldInvoceTitle) {
          const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, this.getInvoiceTitleList(charge.accountId))
          if (!flag && charge.invoiceTitle !== oldInvoceTitle && charge.accountId > 0 && params.field === 'accountId') {
            await ChargeUtils.updateOverseaByAccountId(charge)
          }
        }
      } else if (charge.accountId > 0) {
        if (params.field === 'accountId') {
          await ChargeUtils.updateOverseaByAccountId(charge)
        }
      }
      const office = this.$store.getters.currentOffice
      if (!charge.whtTaxRate && office.whtTaxMode && charge.invoiceTitle && charge.chargeItemId && (charge.invoiceTitle !== oldInvoceTitle || params.field === 'invoiceTitle' ||
      charge.chargeItemId !== oldChargeItemId || params.field === 'chargeItemId')) {
        const invoiceTitleList = this.getInvoiceTitleList(charge.accountId)
        if (invoiceTitleList) {
          const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
          if (invoiceTitle && invoiceTitle.suitWhtTax) {
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
            if (chargeItem && chargeItem.defaultWhtRate > 0) {
              charge.whtTaxRate = chargeItem.defaultWhtRate
            }
          }
        }
      }
      if (charge.whtTaxRate !== oldWhtTaxRate || params.field === 'whtTaxRate' || charge.excludingTaxAmount !== oldExcludingTaxAmount) {
        if (charge.whtTaxRate > 0 && charge.excludingTaxAmount > 0) {
          charge.whtTaxAmount = NumberUtils.ToFixed2(charge.excludingTaxAmount * charge.whtTaxRate / 100, 2)
        } else {
          charge.whtTaxAmount = 0
        }
      }
      this.gridOptions.api.refreshCells({ force: true })
    },
    getInvoiceTitleList(accountId) {
      if (this.currentViewCacheData.customerTitlesMap.get(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    },
    async getTitlesByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      if (this.currentViewCacheData.customerTitlesMap.has(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      let dbTitles = res.data
      if (!dbTitles) dbTitles = []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.currentViewCacheData.customerTitlesMap.set(accountId, dbTitles)
      return this.currentViewCacheData.customerTitlesMap.get(accountId)
    },
    refreshSerialNumber(isAr, charges) {
      let number = 0
      if (!charges) return number
      for (const c of charges) {
        if (c.receivable === isAr) {
          number++
        }
      }
      return number
    },
    cancel() {
      this.rowData = []
      this.totalCurrencyCharge.arData = []
      this.totalCurrencyCharge.apData = []
      this.$emit('close')
    },
    // 费用项目过滤
    getChargeItemFilter() {
      let filter = {}
      switch (this.job.lob) {
        case 'SE':
          filter = { seaExport: true, active: true }
          break
        case 'SI':
          filter = { seaImport: true, active: true }
          break
        case 'AE':
          filter = { airExport: true, active: true }
          break
        case 'AI':
          filter = { airImport: true, active: true }
          break
        case 'RE':
        case 'RI':
          filter = { railwayExport: true, active: true }
          break
        default:
      }
      if (this.defaultProperties.isAr) {
        if (!this.privilege.isControlled) {
          filter.controlled = false
        }
      } else {
        if (!this.privilege.isCostControlled) {
          filter.controlled = false
        }
      }
      return filter
    },
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencySet = new Set(results)
      this.initCargoDocSet()
    },

    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.currentViewCacheData.chargeItemSet = new Set(results)
    },

    async initCargoDocSet() {
      const jobClass = new SeaExportJob(this.job)
      await jobClass.getCargoDoc()
      this.currentViewCacheData.mblCargoDocSet = new Set()
      this.currentViewCacheData.hblCargoDocSet = new Set()
      const j = this.job
      for (const seDoc of this.job.cargoDoc || []) {
        if (j.lob === 'SE' || j.lob === 'SI') {
          if (seDoc.docType === CargoDocConsts.MBL && j.signMBL) {
            if (!StrUtils.isEmpty(this.job.mbl)) {
              seDoc.chargeRelatedBLNo = this.job.mbl
              this.currentViewCacheData.mblCargoDocSet.add(seDoc)
            }
          } else if (seDoc.docType === CargoDocConsts.MBL2 && j.signMBL && j.typeMBL !== 1 && !seDoc.deleted) {
            if (!StrUtils.isEmpty(seDoc.mblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.mblNbr2
              this.currentViewCacheData.mblCargoDocSet.add(seDoc)
            }
          } else if ((seDoc.docType === CargoDocConsts.HBL || (seDoc.docType === CargoDocConsts.HBL2 && j.typeHBL !== 1)) && !seDoc.deleted && j.signHBL && !j.masterFlag) {
            if (!StrUtils.isEmpty(seDoc.hblNbr2)) {
              seDoc.chargeRelatedBLNo = seDoc.hblNbr2
              this.currentViewCacheData.hblCargoDocSet.add(seDoc)
            }
          }
        }
      }
      this.getAllContainerNoHandler()
    },
    /**
     * 申请删除费用
     *
     */
    applyDeleteCharge() {
      const changeCharges = []
      for (const charge of this.rowData) {
        if (StrUtils.isEmpty(charge.changeReason)) {
          this.$message.warning(this.$t('ChangeCharge.changeReasonCannotBeNull'))
          return
        }
        if (charge.changeReason.length > 100) {
          this.$message.warning(this.$t('ChangeCharge.changeReasonIsTooLong'))
          return
        }
        charge.unitRate = -charge.unitRate
        charge.amount = -charge.amount
        charge.taxAmount = -charge.taxAmount
        charge.excludingTaxAmount = -charge.excludingTaxAmount
        const changeCharge = {}
        changeCharge.changeReason = charge.changeReason
        changeCharge.branchId = this.officeId
        changeCharge.actionType = 2
        changeCharge.chargeVO = charge
        changeCharges.push(changeCharge)
      }
      this.toApplyCharge(changeCharges)
    },
    async toApplyCharge(changeCharges) {
      this.loading = getLoading()
      console.log('applyCharge', changeCharges)
      await batchCreateChangeCharge(changeCharges).then(async res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.$emit('returnCall', res.data)
        this.cancel()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 保存费用校验
    validateCharge(charge) {
      if (isNaN(charge['accountId']) || Number(charge['accountId']) <= 0) {
        this.$message.warning(this.$t('Message.SettlementPartyCannotBeNull'))
        return false
      }
      if (isNaN(charge['chargeItemId']) || Number(charge['chargeItemId']) <= 0) {
        this.$message.warning(this.$t('Message.ChargeNameCannotBeEmpty'))
        return false
      }
      if (isNaN(charge['quantity']) || Number(charge['quantity']) === 0) {
        this.$message.warning(this.$t('Message.AmountCannotBeZero'))
        return false
      }
      if (isNaN(charge['exchangeRate']) || Number(charge['exchangeRate']) === 0) {
        this.$message.warning(this.$t('Message.ExchangeCannotBeZero2'))
        return false
      }
      if (charge['remarks'] && charge['remarks'].length > 50) {
        this.$message.warning(this.$t('Message.RemarkTheLengthCannotExceed'))
        return false
      }
      if (!charge.changeReason) {
        this.$message.warning(this.$t('ChangeCharge.changeReasonCannotBeNull'))
        return false
      }
      if (charge.changeReason.length > 100) {
        this.$message.warning(this.$t('ChangeCharge.changeReasonIsTooLong'))
        return false
      }
      if (charge.chargeItemId) {
        const message = ChargeUtils.checkChargeRateRange(charge)
        if (message) {
          this.$message.warning(this.$t('CargoMsg.Cargo_TaxRateRangeLimit', [message]))
          return
        }
      }
      return true
    },
    getAllContainerNoHandler() {
      if (this.job.containers) {
        this.currentViewCacheData.containerNoAllSet = new Set()
        for (const c of this.job.containers) {
          if (c.containerNo) {
            const cData = {}
            cData['containerNo'] = c.containerNo
            this.currentViewCacheData.containerNoAllSet.add(cData)
          }
        }
      }
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
    },
    // 列表checkBox选中变更事件
    toRefreshSelectedCountChargeGrid() {
      this.selections = getGridSelected(this.gridOptions)
      if (this.selections.length > 0) {
        this.once.excute(this.refreshSelectedCountChargeGrid, [0, this.selections], 200)
      } else {
        this.$nextTick(() => {
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length === this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [], 200)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
            }
          } else {
            this.once.excute(this.refreshSelectedCountChargeGrid, [1, hasDisplay], 200)
          }
        })
      }
    },
    refreshSelectedCountChargeGrid(arg, selections) {
      const arData = []
      const apData = []
      if (arg === 0 || arg === 1) {
        for (const item of selections) {
          if (item.receivable) {
            arData.push(item)
          } else {
            apData.push(item)
          }
        }
      } else {
        for (const item of this.rowData) {
          if (item.receivable) {
            arData.push(item)
          } else {
            apData.push(item)
          }
        }
      }
      this.totalCurrencyCharge.arData = arData
      this.totalCurrencyCharge.apData = apData
    },
    // CARGO-37588 申请新增费用，添加抄录功能
    // 抄录费用
    copyChargeHandler() {
      if (!this.job) {
        this.$message.info(this.$t('Message.TheCurrentlyRelevantBusinessInformationIsNull'))
        return
      }
      const job = this.job
      this.copyChargeDialog.isSea = job.lob === 'SE' || job.lob === 'SI'
      this.copyChargeDialog.lob = job.lob
      this.copyChargeDialog.receivable = this.defaultProperties.isAr ? 1 : 0
      console.log(this.copyChargeDialog)
      console.log(this.defaultProperties)
      this.copyChargeDialog.visible = true
    },
    // 抄录费用-选择费用后返回事件
    async selectedCopyChargeHandler(chargeList) {
      const costCharges = chargeList
      let i = 0
      const localCurrency = RateUtil.localCurrencyByOfficeId(this.getBranchIdForCharge())
      this.copyedChargeList = []
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      for (const charge of costCharges) {
        const obj = new Charge().fillDefaultValue().getData()
        obj.uuid = ''
        obj.jobUuid = this.job.uuid
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
        obj.chargeItemId = charge.chargeItemId
        obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
        obj.accountId = this.config.accountObjectControlMode && charge.receivable ? this.job.customerId : charge.accountId
        if (obj.accountId && obj.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', obj.accountId)
          // CARGO-36892,合作伙伴无效时置为0
          if (!company || !company.active) {
            obj.accountId = 0
          }
        }
        if (obj.accountId && obj.accountId > 0) {
          await this.getSettlementByCompanyId(obj)
        }
        obj.inputBy = this.$store.getters.userId
        obj.inputDate = DateUtils.formatStandardDateTime(new Date())
        obj.oversea = charge.oversea
        obj.currency = charge.currency
        obj.measure = charge.measure
        if (parseInt(cache.config.get('openHecConfig')) === 1) {
          obj.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
        }
        obj.receivable = charge.receivable
        obj.unitRate = charge.unitRate
        obj.taxRate = charge.taxRate
        obj.quantity = charge.quantity
        if (obj.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
        } else {
          ChargeUtils.calculateTax(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
        }
        obj.verifiedAmount = 0
        obj.accountingDate = null
        obj.counterPartyBillingNo = null
        // 序号，CARGO-5881，按照录入顺序排序
        // 后端的  syncBranchId 在前端此处赋值即可
        obj.branchId = this.privilege.showOtherBranchCharge ? this.currentSettleBranchId : this.getBranchIdForCharge()
        obj.inputByDep = this.job.opDepartment
        obj.businessDate = this.job.businessDate
        obj.localCurrency = localCurrency
        obj.dateType = this.dateType
        obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this.job, obj.branchId)
        // this.fillDefaultCopyValueByCharge(obj, charge, this.job, false)
        // await ChargeUtils.getChargeisOverseaNotControlledByConfig(obj)
        await ChargeUtils.updateDefaultInvoiceTitle([obj])
        i++
        this.copyedChargeList.push(obj)
        this.rowData.push(obj)
      }
      // 抄录的有禁用的收费项目提示
      if (haveDisableItem) {
        this.$message.warning(this.$t('Message.Some_Items_Have_Expired'))
        await sleep(100)
      }
      if (i > 0) {
        this.copyChargeDialog.visible = false
        this.$message.info(this.$t('Message.CopyChargeSuccessfullyTotallyOfNItems1') + ' ' + i + ' ' + this.$t('Message.CopyTheReceivablesSuccessfullyTotallyOfNItems2'))
      } else {
        this.$message.info(this.$t('Message.NoChargeCanBeCopiedThereMayBeSameChargeItems'))
        return
      }
      await this.refreshCopyedChargeTitle()
      if (this.copyedChargeList != null && this.copyedChargeList.length > 0) {
        for (const charge of this.copyedChargeList) {
          await this.loadChargeWht(charge)
        }
      }

      let arCount = 0
      let apCount = 0
      const arData = []
      const apData = []
      for (const item of this.rowData) {
        if (item.receivable) {
          arCount = arCount + 1
          arData.push(item)
        } else {
          apCount = apCount + 1
          apData.push(item)
        }
      }
      this.totalCurrencyCharge.arData = arData
      this.totalCurrencyCharge.apData = apData
      this.totalCurrencyCharge.arCount = arCount
      this.totalCurrencyCharge.apCount = apCount
    },
    // 带出费用WHT税率和税额
    async loadChargeWht(charge) {
      const office = this.$store.getters.currentOffice
      charge.whtTaxAmount = 0
      if (office.whtTaxMode && charge.invoiceTitle && charge.chargeItemId) {
        const invoiceTitleList = await this.getTitlesByCompanyId(charge)
        if (invoiceTitleList) {
          const invoiceTitle = invoiceTitleList.find(p => p.title === charge.invoiceTitle)
          if (invoiceTitle && invoiceTitle.suitWhtTax) {
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
            if (chargeItem && chargeItem.defaultWhtRate > 0) {
              charge.whtTaxRate = chargeItem.defaultWhtRate
              if (charge.whtTaxRate > 0 && charge.excludingTaxAmount > 0) {
                charge.whtTaxAmount = NumberUtils.ToFixed2(charge.excludingTaxAmount * charge.whtTaxRate / 100, 2)
              }
            }
          }
        }
      }
    },
    // 更新费用抬头【多票费用】
    async refreshCopyedChargeTitle(charges = null) {
      const copyedChargeList = charges || this.copyedChargeList
      if (copyedChargeList != null && copyedChargeList.length > 0) {
        await ChargeUtils.updateDefaultInvoiceTitle(copyedChargeList)
      }
    },
    currentSettleBranchId() {
      return (this.config.currentOfficeCharge && this.job.salesOffice) ? this.job.salesOffice : this.$store.getters.currentOfficeId
    },
    /**
     * 获取费用结算公司
     */
    getBranchIdForCharge() {
      return (this.config.currentOfficeCharge && this.job.salesOffice) ? this.job.salesOffice : this.job.opOffice
    },
    // 根据结算对象，获取结算代理
    async getSettlementByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      const chargeAccount = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
      if (!chargeAccount) {
        return
      }
      if (this.currentViewCacheData.customerSettlementAgentMap.has(accountId)) {
        const staticOptions = this.currentViewCacheData.customerSettlementAgentMap.get(accountId)
        const index = staticOptions.findIndex(p => p.uuid === chargeAccount.uuid)
        if (index < 0) {
          if (chargeAccount) {
            staticOptions.push(chargeAccount)
          }
          this.currentViewCacheData.customerSettlementAgentMap.set(accountId, staticOptions)
        }
        charge.settlementAgentId = staticOptions[0].cmpIdx
      } else {
        const res = await getSettlementAgentsByCmpIdx(charge.accountId)
        let dbSettlementAgents = res.data
        if (!dbSettlementAgents) dbSettlementAgents = []
        if (chargeAccount) {
          const index = dbSettlementAgents.findIndex(p => p.uuid === chargeAccount.uuid)
          if (index < 0) {
            dbSettlementAgents.push(chargeAccount)
          }
        }
        charge.settlementAgentId = dbSettlementAgents[0].cmpIdx
        this.currentViewCacheData.customerSettlementAgentMap.set(accountId, dbSettlementAgents)
      }
    },
    whtTaxAmountConversionRMBLabel(charge) {
      if (charge) {
        const whtTaxAmount = new BigNumber(charge.whtTaxAmount)
        const exchangeRate = new BigNumber(charge.exchangeRate)
        const num = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(multiply(whtTaxAmount, exchangeRate), charge.localCurrency), 2)
        charge.whtTaxLocalAmount = num
        return this.$numeral(num).format('0.00')
      }
      return '0.00'
    },
    chargeSchemeHandler() {
      if (!this.job) {
        this.$message.info(this.$t('Message.TheCurrentlyRelevantBusinessInformationIsNull'))
        return
      }
      const job = this.job
      this.chargePlanDialog.isSea = job.lob === 'SE' || job.lob === 'SI'
      this.chargePlanDialog.lob = job.lob
      this.chargePlanDialog.chargeSchemeIsApproved = Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.chargePlanDialog.visible = true
    },
    // 费用方案 -选择费用后事件
    async selectedSchemeHandler(schemeDetails) {
      if (!schemeDetails || schemeDetails.length <= 0) return
      if (this.config.accountObjectControlMode) {
        for (const schemeDetail of schemeDetails) {
          if (schemeDetail.receivable) {
            schemeDetail.accountId = this.job.customerId
          }
        }
      }
      const chargeBranchId = this.privilege.showOtherBranchCharge ? this.currentSettleBranchId : this.getBranchIdForCharge()
      const charges = await ChargeUtils.applyChargeScheme(this.job, schemeDetails, 0, parseInt(cache.config.get('GetHBLcWeight')) === 1, chargeBranchId)
      // CARGO-33201 选择费用方案后若开启合创交单参数则默认未提交
      const openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
      for (const charge of charges) {
        if (openHecConfig) {
          charge.sapStatus = ChargeUtilsForConstant.CHARGE_US.code
        }
        if (this.config.currentOfficeCharge && this.job.salesOffice) {
          charge.branchId = this.job.salesOffice
        }
        if (charge.accountId && charge.accountId > 0) {
          const company = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', charge.accountId)
          // CARGO-36892,合作伙伴无效时置为0
          if (!company.active) {
            charge.accountId = 0
          }
        }
      }
      if (this.privilege.showOtherBranchCharge && charges && charges.length > 0) charges.forEach(charge => { charge.branchId = this.currentSettleBranchId })
      // CARGO-1072，默认开票抬头：通过费用方案
      await ChargeUtils.updateDefaultInvoiceTitle(charges)
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      if (charges && charges.length > 0) {
        const accountTitleMap = new Map()
        this.$logger.log('费用方案--changeCharge', charges)
        for (const charge of charges) {
          // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
          if (!chargeItem || !chargeItem.active) {
            haveDisableItem = true
            continue
          }
          if (charge.accountId && charge.accountId > 0) {
            await this.getSettlementByCompanyId(charge)
            // CARGO-35852 通过费用方案生成费用，没有按照开票要求里选的国内国外，生成费用的国内国外（有备注）
            const canChangeOverseaOfCharge = parseInt(cache.config.get('canChangeOverseaOfCharge'))
            if (canChangeOverseaOfCharge !== 2 && canChangeOverseaOfCharge !== 3) {
              if (charge.invoiceTitle) {
                let invoiceTitleList = null
                if (accountTitleMap.has(charge.accountId)) {
                  invoiceTitleList = accountTitleMap.get(charge.accountId)
                } else {
                  invoiceTitleList = await ChargeUtils.getTitleListByCompanyCmpIdx(charge.accountId)
                  accountTitleMap.set(charge.accountId, invoiceTitleList)
                }
                const flag = ChargeUtils.updateOverseaByInvoiceTitle(charge, invoiceTitleList)
                if (!flag) { // 费用的开票抬头不在结算对象维护的开票抬头中时，根据结算对象带出默认的国内国外
                  await ChargeUtils.updateOverseaByAccountId(charge)
                }
              } else if (charge.accountId > 0) {
                await ChargeUtils.updateOverseaByAccountId(charge)
              }
            }
          }
          await this.loadChargeWht(charge)
          this.rowData.push(charge)

          let arCount = 0
          let apCount = 0
          const arData = []
          const apData = []
          for (const item of this.rowData) {
            if (item.receivable) {
              arCount = arCount + 1
              arData.push(item)
            } else {
              apCount = apCount + 1
              apData.push(item)
            }
          }
          this.totalCurrencyCharge.arData = arData
          this.totalCurrencyCharge.apData = apData
          this.totalCurrencyCharge.arCount = arCount
          this.totalCurrencyCharge.apCount = apCount
        }
        // 抄录的有禁用的收费项目提示
        if (haveDisableItem) {
          this.$message.warning(this.$t('Message.Some_Items_Have_Expired'))
          await sleep(100)
        }
      }
    },
    async getCache(dateTypeConfigKeyAr, dateTypeConfigKeyAp) {
      if (this.defaultProperties.isAr) {
        this.dateType = LocalStorageUtilsNew.getConfiguration(dateTypeConfigKeyAr, 'string')
      } else {
        this.dateType = LocalStorageUtilsNew.getConfiguration(dateTypeConfigKeyAp, 'string')
      }
    }
  }
}
</script>
<style lang="scss">
  .change-charge-window {
    label {
      font-size: 12px;
      font-weight: normal;
    }
    .el-select {
      width: 100%;
    }
  }
</style>
